import { bareIzteachClient } from '../clients';
import { retryColdStart } from '../core/coldStart';
import { libraryVendorId } from '../session';
import type { IztHomework } from '../types';

// IZTeach homework-service GET is public; LTV students submit on the content tenant, so that vendorId filters
export const HomeworkSubmissionRepository = {
  /** Newest first; `emailPattern` is a regex the service applies case-insensitively (`email_contain`). */
  listByEmail: (emailPattern: string, limit: number) =>
    retryColdStart(() =>
      bareIzteachClient('exam')
        .get('/homework', { params: { vendorId: libraryVendorId(), email_contain: emailPattern, _sort: 'submitTime:-1', _limit: limit } })
        .then((res) => (Array.isArray(res.data) ? res.data as IztHomework[] : [])),
    ),
};

export default HomeworkSubmissionRepository;
